import { Language } from '@src/common/i18n/Language';
import { useTranslation } from 'react-i18next';

export const useSelectedLanguage = () => {
  const { i18n } = useTranslation();
  const languageCode = i18n.language.split('-')[0];

  return {
    selectedLanguage: languageCode === 'fr' ? Language.FR : Language.EN,
    isFrench: languageCode === 'fr',
  };
};
